import { pathOr } from "ramda";

export const generateFormsMeta = ({ meta, utmParams }) => {
	if (
		!utmParams ||
		Object.keys(utmParams).length === 0 ||
		Object.values(utmParams).length === 0
	) {
		return meta;
	}

	const questions = pathOr([], ["forms", "questions"], meta);
	const type = pathOr(null, ["forms", "type"], meta);

	const formsMeta = {
		forms: {
			type,
			questions: [
				...questions,
				{
					question: "UTM",
					answer: Object.values(utmParams).join("-"),
				},
			],
		},
	};

	return formsMeta;
};
